// function distance(x1, x2, y1, y2){
//   return Math.sqrt( (x2-=x1)*x2 + (y2-=y1)*y2 );
// }

// function countUpToNumber(element, n, d) {
//   element.prop('Counter',0).delay(100).animate({
//     Counter: n
//   }, {
//     duration: d,
//     easing: 'swing',
//     step: function (now) {
//       var formattedNumber = numeral(Math.ceil(now)).format('0,0');
//       element.text(formattedNumber);
//     }
//   });
// }

// function animateNumbers() {
  /*var $attacksNumber = $("#attacksNumber"), $preventedNumber = $("#preventedNumber");
  if(!aCounterRunning){
    $attacksNumber.css('opacity', 1);
    var atotal = $attacksNumber.data("total");
    countUpToNumber($attacksNumber, atotal, 3000);
    aCounterRunning = true;
  }
  if(!pCounterRunning) {
    $preventedNumber .css('opacity', 1);
    var ptotal = $preventedNumber.data("total");
    countUpToNumber($preventedNumber, ptotal, 3000);
    pCounterRunning = true;
  }*/
// }

// function animateSamplesCollectedNumber() {
  /*var $samples = $("#samples-collected-number");
  var scTotal = $samples.data("total");
  if(!scCounterRunning){
    $samples.css('opacity', 1);
    countUpToNumber($samples, scTotal, 3000);
    scCounterRunning = true;
  }*/
// }

var windowHeight = $(window).height();
var defaultOffset = -windowHeight*.1;
var attacksCounted = false;
var preventionsCounted = false;

if($(window).width() > 768 ) {
  var controller = new ScrollMagic.Controller();

  // function pathPrepare ($el) {
  //   var line = $el.get(0),
  //   lineLength = distance(line.x1.baseVal.value, line.x2.baseVal.value, line.y1.baseVal.value, line.y2.baseVal.value);
  //   $el.css('stroke-dasharray', lineLength);
  //   $el.css('stroke-dashoffset', lineLength);
  //   $el.css('opacity', 1);
  // }

  // $('line').each(function(){
  //   pathPrepare($(this));
  // });


  /* scene 3 ---------------------------------------------------------------- */
  // var line3 = $('#line-03');
  function startDrawingDiagramOne(){
    document.getElementById("chart_1").play();
  }
  var scene3Tween = new TimelineMax({onStart: startDrawingDiagramOne})
      // .add(TweenMax.to(line3, 0.9, {strokeDashoffset: 0, ease:Linear.easeNone}))
      // .add(TweenMax.to($('#circle-03'), 0.1, {opacity: 1, ease:Linear.easeNone}), '-=0.1')
      .add(TweenMax.to($('#p3-blurb'), 0.1, {opacity: 1, top: 105, ease:Linear.easeNone}));

  new ScrollMagic.Scene({
      triggerElement: "#p3",
      duration: $("#p5").height(),
      offset: -windowHeight*.4
    })
    //.addIndicators({name: "Scene 3"})
    .setTween(scene3Tween)
    .addTo(controller);


  /* scene 4 ---------------------------------------------------------------- */
  // var line4 = $('#line-04');
  // var scene4Tween = new TimelineMax()
  //   // .add(TweenMax.to(line4, 0.5, {strokeDashoffset: 0, ease:Linear.easeNone}))
  //   // .add(TweenMax.to($('#circle-04'), 0.1, {opacity: 1, ease:Linear.easeNone}), '-=0.05')
  //   .add(TweenMax.to($('#p4-paragraph'), 0.2, {opacity: 1, top: 0, ease:Linear.easeNone}));
  //   // .add(TweenMax.to($('#line-04b'), 0.2, {strokeDashoffset: 0, ease:Linear.easeNone}), '-=0.2')
  //   // .add(TweenMax.to($('#line-04c'), 0.2, {strokeDashoffset: 0, ease:Linear.easeNone}), '-=0.2');

  // new ScrollMagic.Scene({
  //     triggerElement: "#p4",
  //     duration: 400,
  //     offset: -200
  //   })
  //   .setTween(scene4Tween)
  //   //.addIndicators({name: "Scene 4"})
  //   .addTo(controller);


  /* scene 5 ---------------------------------------------------------------- */
  // // var line5 = $('#line-05');
  // // var scene5Tween = new TimelineMax({onComplete:animateNumbers})
  // //     .add(TweenMax.to(line5, 0.1, {strokeDashoffset: 0, ease:Linear.easeNone}))
  // //     .add(TweenMax.to($('#circle-05'), 0.1, {opacity: 1, ease:Linear.easeNone}), '-=0.1')

  // var aCounterRunning = false;
  // var pCounterRunning = false;
  // var scCounterRunning = false;

  // new ScrollMagic.Scene({
  //     triggerElement: "#p5",
  //     duration: $("#p5").height()-100,
  //     offset: -200
  //   })
  //   // .setTween(scene5Tween)
  //   //.addIndicators({name: "Scene 5"})
  //   .addTo(controller);


  /* scene 6 ---------------------------------------------------------------- */
  // var scene6Tween = new TimelineMax()
  //   .add(TweenMax.to($('#p6-paragraph'), 0.2, {opacity: 1, top: 100, ease:Linear.easeNone}))
  //   // .add(TweenMax.to($('#line-06'), 0.5, {strokeDashoffset: 0, ease:Linear.easeNone}))
  //   // .add(TweenMax.to($('#line-06c'), 0.2, {strokeDashoffset: 0, ease:Linear.easeNone}))
  //   // .add(TweenMax.to($('#line-06b'), .5, {strokeDashoffset: 0, ease:Linear.easeNone}), '-=0.2')
  //   // .add(TweenMax.to($('#circle-06'), 0.1, {opacity: 1, ease:Linear.easeNone}), '-=0.1')

  // new ScrollMagic.Scene({
  //     triggerElement: "#p6",
  //     duration: windowHeight*.9,
  //     offset: -windowHeight/3
  //   })
  //   .setTween(scene6Tween)
  //   //.addIndicators({name: "Scene 6"})
  //   .addTo(controller);


  /* scene 7 ---------------------------------------------------------------- */
  var scene7Tween = new TimelineMax()
  //   // .add(TweenMax.to($('#line-07'), 0.5, {strokeDashoffset: 0, ease:Linear.easeNone}))
  //   // .add(TweenMax.to($('#circle-07'), 0.1, {opacity: 1, ease:Linear.easeNone}), '-=0.1')
  //   .add(TweenMax.to($('#p7-blurb'), 0.2, {opacity: 1, top: 125, ease:Linear.easeNone}))

  new ScrollMagic.Scene({
  //     triggerElement: "#p7",
  //     duration: $("#p7").height()-200,
  //     offset: defaultOffset
    })
    .on("enter", function (e) {
      var v = document.getElementById("chart_2");
      v.play();
    })
    .setTween(scene7Tween)
  //   //.addIndicators({name: "Scene 7"})
    .addTo(controller);


  /* scene 8 ---------------------------------------------------------------- */
  var scene8Tween = new TimelineMax()
    // .add(TweenMax.to($('#line-07b'), 4, {strokeDashoffset: 0, ease:Linear.easeNone}))
    // .add(TweenMax.to($('#circle-07b'), 2, {opacity: 1, ease:Linear.easeNone}), '-=0.5')
    // .add(TweenMax.to($('#circle-07b'), 2, {opacity: 1, ease:Linear.easeNone}), '-=0.5')
    .add(TweenMax.to($('#band-1'), 2, {opacity: 1, ease:Linear.easeNone}), '-=0.5')
    .add(TweenMax.to($('#band-2'), 2, {opacity: 1, ease:Linear.easeNone}), '-=0.5')
    .add(TweenMax.to($('#band-3'), 2, {opacity: 1, ease:Linear.easeNone}), '-=0.5')
    .add(TweenMax.to($('#band-4'), 2, {opacity: 1, ease:Linear.easeNone}), '-=0.5')
    // .add(TweenMax.to($('#line-08'), 4, {strokeDashoffset: 0, ease:Linear.easeNone}))
    .add(TweenMax.to($('#phone'), 1, {opacity: 1,  ease:Linear.easeNone}))
    .add(TweenMax.to($('#nest-fridge-line, #fridge, #laptop'), 1, {opacity: 1,  ease:Linear.easeNone}))
    .add(TweenMax.to($('#lock-kettle-line, #kettle'), 1, {opacity: 1,  ease:Linear.easeNone}))
    .add(TweenMax.to($('#bulb'), 1, {opacity: 1,  ease:Linear.easeNone}))
    // .add(TweenMax.to($('#p8-blurb'), 1, {opacity: 1, top: 600, ease:Linear.easeNone}))

  new ScrollMagic.Scene({
      triggerElement: "#p8",
      duration: windowHeight*.9,
      offset: -windowHeight/2
    })
    .setTween(scene8Tween)
    //.addIndicators({name: "Scene 8"})
    .addTo(controller);



  /* scene 9 ---------------------------------------------------------------- */
  // var scene9Tween = new TimelineMax()
  //   // .add(TweenMax.to($('#line-09'), 1, {strokeDashoffset: 0, ease:Linear.easeNone}))
  //   // .add(TweenMax.to($('#circle-09'), .1, {opacity: 1, ease:Linear.easeNone}))
  //   .add(TweenMax.to($('#p9-paragraph'), .1, {opacity: 1, top: 480, ease:Linear.easeNone}));
  //   // .add(TweenMax.to($('#line-09b'), .1, {strokeDashoffset: 0, ease:Linear.easeNone}), '-=0.1')
  //   // .add(TweenMax.to($('#line-09c'), .1, {strokeDashoffset: 0, ease:Linear.easeNone}), '-=0.1');

  // new ScrollMagic.Scene({
  //     triggerElement: "#p9",
  //     duration: $("#p9").height()-100,
  //     offset: 0
  //   })
  //   .setTween(scene9Tween)
  //   //.addIndicators({name: "Scene 9"})
  //   .addTo(controller);



  /* scene 10 ---------------------------------------------------------------- */
  // var scene10Tween = new TimelineMax({onComplete: animateSamplesCollectedNumber})
  //   // .add(TweenMax.to($('#line-10'), 5, {strokeDashoffset: 0, ease:Linear.easeNone}))
  //   // .add(TweenMax.to($('#circle-10'), 0.5, {opacity: 1, ease:Linear.easeNone}))
  //   .add(TweenMax.to($('#p10-blurb'), 1, {opacity: 1, top: 90, ease:Linear.easeNone}))

  // new ScrollMagic.Scene({
  //     triggerElement: "#p10",
  //     duration: $("#p10").height()-200,
  //     offset: defaultOffset
  //   })
  //   .setTween(scene10Tween)
  //   //.addIndicators({name: "Scene 10"})
  //   .addTo(controller);


  /* scene CTA ---------------------------------------------------------------- */
  // var ctaSceneTween = new TimelineMax()
  //   .add(TweenMax.to($('#line-10b'), .9, {strokeDashoffset: 0, ease:Linear.easeNone}))

  new ScrollMagic.Scene({
      triggerElement: "#cta",
      duration: windowHeight*.33,
      offset: defaultOffset
    })
    // .setTween(ctaSceneTween)
    //.addIndicators({name: "CTA Scene"})
    .addTo(controller);


  /* scene Brand Video ---------------------------------------------------------------- */
  var brandVideoSceneTween = new TimelineMax()
    .add(TweenMax.to($('#circle-10b'), 0.5, {opacity: 1, ease:Linear.easeNone}))
  var bv = document.getElementById("brand-video");
  new ScrollMagic.Scene({
      triggerElement: "#brand-video",
      duration: $("#brand-video").height()-100,
      offset: -200
    })
    .setTween(brandVideoSceneTween)
    .on("enter", function (e) {
      var direction = e.target.controller().info("scrollDirection");
      if(direction === "FORWARD") bv.play();
    })
    .on("leave", function (e) {
      var direction = e.target.controller().info("scrollDirection");
      if(direction === "REVERSE") bv.pause();
    })
    //.addIndicators({name: "Brand Video Scene"})
    .addTo(controller);
}
